<template>
  <div>
    <div class="soha-progress-info">
      <div class="soha-progress-title">
        {{ label }}
      </div>
      <div
        v-if="showMax"
        class="soha-progress-from"
      >
        {{ $t(`${I18nPrefix}FROM`) }} {{ toPersianDigits(max) }}
      </div>
    </div>
    <div class="soha-progress-container">
      <div
        class="soha-progress-loader"
        :class="`soha-progress-${variant}`"
        :style="computeWidth"
      >
        <div
          v-if="showValue"
          class="soha-progress-value"
        >
          {{ toPersianDigits(value) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/base/button.scss";
import "@/assets/css/components/base/circular-loading.css";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "Progress",
  mixins: [UIMixin],
  props: {
    value: Number,
    label: {
      default: null,
      type: String,
    },
    showMax: {
      default: true,
      type: Boolean,
    },
    showValue: {
      default: true,
      type: Boolean,
    },
    max: {
      default: 100,
      type: Number,
    },
    variant: {
      default: "secondary",
      type: String,
    },
    height: {
      default: "2.308rem",
    },
  },

  data() {
    return {
      I18nPrefix: "COMPONENTS.BASE.PROGRESS.",
    };
  },

  computed: {
    computeWidth() {
      return "width:" + (this.value * 100) / this.max + "%";
    },
  },

  methods: {},
};
</script>

<style scoped>
.soha-progress-container {
  width: 100%;
  height: v-bind(height);
  background: var(--muted-background-color);
  border-radius: 0.385rem;
  position: relative;
}
.soha-progress-loader {
  border-radius: 0.385rem;
  height: v-bind(height);
  max-width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.soha-progress-primary {
  background: var(--primary-color);
}
.soha-progress-danger {
  background: var(--danger-color);
}
.soha-progress-secondary {
  background: var(--secondary-color);
}
.soha-progress-warning {
  background: var(--tag-dark-yellow-color);
}
.soha-progress-success {
  background: var(--tag-dark-green-color);
}
.soha-progress-value {
  color: white;
}
.soha-progress-from {
  text-align: left;
  font-weight: bold;
  color: var(--primary-color);
  padding-left: 0.385rem;
}
.soha-progress-info {
  display: flex;
  justify-content: space-between;
}
.soha-progress-title {
  color: var(--primary-color);
  padding-right: 0.385rem;
}
</style>
